import {useCallback, useState} from 'react';
import {downloadMediaFile} from '../lib/download';
import {useNotifications} from '../lib/notifications';

export interface DownloadableMedia {
  id: string;
  url: string;
  fileName?: string;
}

interface UseMediaDownloadResult {
  download: (item: DownloadableMedia) => Promise<void>;
  downloadingId: string | null;
}

// Имя для скачивания: fileName, иначе — базовое имя, производное от url/id (storageKey).
// Сырой storageKey брать нельзя: он может содержать «/» и не иметь расширения.
const resolveDownloadFileName = (item: DownloadableMedia): string => {
  if (item.fileName) return item.fileName;
  const source = item.url || item.id;
  const path = source.split(/[?#]/)[0];
  const base = path.slice(path.lastIndexOf('/') + 1);
  return base || item.id;
};

export const useMediaDownload = (): UseMediaDownloadResult => {
  const [downloadingId, setDownloadingId] = useState<string | null>(null);
  const {createNotification} = useNotifications();

  const download = useCallback(async (item: DownloadableMedia) => {
    setDownloadingId(item.id);
    try {
      const fileName = resolveDownloadFileName(item);
      await downloadMediaFile(item.url, fileName);
    } catch {
      createNotification({
        name: 'media-download-error',
        title: 'Ошибка скачивания файла',
        theme: 'danger',
      });
    } finally {
      setDownloadingId(null);
    }
  }, [createNotification]);

  return {download, downloadingId};
};
